;(function($){

    function Bank_slips() {
        var _       =  this;
        _.API       = $("#app_url").val() + "/api/";
        _.oBankSlip = $("input[name='bank_slips[]']");

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });  

        $("input#bankSlipsAll").on("change", function(e){
            $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
        });

        $("#btn-bank-slips-generate-shipping").on("click", function(e){
            e.preventDefault();
            
            if ($("input[name='bank_slips[]']:checked").length > 0) {

                var isPag = false;

                $("input[name='bank_slips[]']:checked").each(function( index, value) {
                    
                    if($(value).data('status') == 1) {
                        isPag = true;                        
                    }
                });

                if(isPag) {
                    swal({
                        type: 'warning',
                        title: 'Atenção!',
                        text: "Você não pode colocar boletos pagos na remessa!",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }); 
                }else {                  
                    _.generate_shipping();
                }

            }else{

                swal({
                    title: "Atenção",
                    text: "Você não marcou os boletos que deseja colocar na remessa!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: true
                });
            }
        });

        $("#bank-slips-legend").on("click", function(e){
            e.preventDefault();

            swal({
              type: 'info',
              html:
                '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #c33434;"></i> Em Aberto </br>' +
                '<i class="fa fa-circle" style="color: #4db300;"></i> Pago </br>' +
                '<i class="fa fa-circle" style="color: #b4b4b4;"></i> Cancelada </br>' +
                '<i class="fa fa-circle" style="color: #000000;"></i> Enviado ao Banco</div>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#0b7789',
              confirmButtonText:
                'Fechar'
            });
        });
    };

    Bank_slips.prototype.checkAll = function() {
        var _ =  this;

        _.oBankSlip.each(function( index, value) {
           $(value).prop('checked', true);
        });
    };

    Bank_slips.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oBankSlip.each(function( index, value) {
           $(value).prop('checked', false);
        });
    };

    Bank_slips.prototype.generate_shipping =  function() {
        var _           = this;
        var bank_slips  = [];
        var data        = new FormData();

        $("input[name='bank_slips[]']:checked").each(function( index, value) {
            bank_slips.push($(value).val());
        }).promise().done(function () { 
            
            swal({
                type: 'warning',
                title: 'Aguarde!',
                text: "Estamos montanto o arquivo remessa com os boletos selecionados.",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                onBeforeOpen: function() {
                    swal.showLoading();
                }
            }); 

            data.append('bank_slips', bank_slips);  

            $.ajax({
                type: "POST",
                url: _.API + "boletos/gerar-remessa",
                data: data,
                dataType: 'json',
                cache: false,
                processData: false, 
                contentType: false, 
                success: function(response)
                {
                    var html = '<table>'+
                       '<thead>'+
                            '<tr>'+
                                '<th>Banco</th>'+
                                '<th>Agência</th>'+
                                '<th>Conta</th>'+
                                '<th>Nº Boletos</th>'+
                                '<th>Arquivo</th>'+
                            '</tr>'+
                        '</thead>'+
                        '<tbody>';                                    
                               
                    var data = response;

                    $.each(data, function( index, value) {
                        html += '<tr>';
                        html += '<td>'+ value.bank +'</td>';    
                        html += '<td>'+ value.agencia +'</td>';   
                        html += '<td>'+ value.conta +'</td>';   
                        html += '<td>'+ value.total +'</td>';  
                        html += '<td><a target="_blank" href="'+$("#app_url").val()+'/downloads/'+value.file+'" class="pull-right btn-default"><i class="fa fa-cloud-download" aria-hidden="true"></i></a></td></tr>';
                    });

                    html += '</tbody>'+
                        '</table>';

                    swal({
                        html: html,
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });
                                                            
                },

                error: function(response) {

                    swal({
                        title: "Error",
                        text: 'Houve um erro ao tentar gerar a remessa.',
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });
                }
            });
        });

    };

   	new Bank_slips();

}(jQuery));
